export class ThemeModel {
    image: File | null;
    color: string;
    banner: File | null;

    constructor() { 
        this.image = null;
        this.color = '';
        this.banner = null;
    }
}
